import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Select,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import AppColors from '../../../constants/AppColors';

function SendToAuditorModal({ isOpen, onClose, onConfirm, specialtyId, currentAuditor, getAvailableAuditors, isLoading }) {
  const [auditors, setAuditors] = useState([]);
  const [selectedAuditorId, setSelectedAuditorId] = useState('');
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setIsFetching(true);
    getAvailableAuditors(specialtyId).then(data => {
      const list = Array.isArray(data) ? data : [];
      setAuditors(list);
      const defaultId = currentAuditor?.id
        ? String(currentAuditor.id)
        : list.length > 0 ? String(list[0].id) : '';
      setSelectedAuditorId(defaultId);
    }).finally(() => setIsFetching(false));
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(selectedAuditorId ? Number(selectedAuditorId) : null);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='sm'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize='md' pb={2}>Send to Auditor</ModalHeader>
        <ModalBody>
          <VStack align='stretch' spacing={3}>
            <Text fontSize='sm' color='gray.600'>
              Select the auditor to send the rebuttal corrections to.
            </Text>
            <Select
              size='sm'
              value={selectedAuditorId}
              onChange={e => setSelectedAuditorId(e.target.value)}
              isDisabled={isFetching || auditors.length === 0}
              placeholder={isFetching ? 'Loading auditors...' : auditors.length === 0 ? 'No auditors available' : undefined}
            >
              {auditors.map(a => (
                <option key={a.id} value={String(a.id)}>{a.name}</option>
              ))}
            </Select>
          </VStack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button size='sm' variant='ghost' onClick={onClose}>Cancel</Button>
          <Button
            size='sm'
            bgColor={AppColors.secondary}
            color='white'
            _hover={{ opacity: 0.9 }}
            isDisabled={!selectedAuditorId || isFetching}
            isLoading={isLoading}
            onClick={handleConfirm}
          >
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default SendToAuditorModal;
